import { FC, MouseEvent, useState } from 'react';
import { CustomTimelineAction, CusTomTimelineRow } from './mock';
import TimelineContextMenu from './audioDeleteMenu';

export type TimelineActionDeleteHandler = (
  action: CustomTimelineAction,
  row: CusTomTimelineRow
) => void;

interface TimelineActionBarProps {
  action: CustomTimelineAction;
  row: CusTomTimelineRow;
  className: string;
  label: string;
  onDelete?: TimelineActionDeleteHandler;
  isContextMenuOpen?: boolean;
  onContextMenuOpen?: TimelineActionDeleteHandler;
  onContextMenuClose?: () => void;
}

const TimelineActionBar: FC<TimelineActionBarProps> = ({
  action,
  row,
  className,
  label,
  onDelete,
  isContextMenuOpen,
  onContextMenuOpen,
  onContextMenuClose,
}) => {
  const [isLocalContextMenuOpen, setIsLocalContextMenuOpen] = useState(false);
  const isMenuOpen = isContextMenuOpen ?? isLocalContextMenuOpen;

  const closeContextMenu = () => {
    if (onContextMenuClose) {
      onContextMenuClose();
    } else {
      setIsLocalContextMenuOpen(false);
    }
  };

  const handleContextMenu = (event: MouseEvent) => {
    if (!onDelete) return;

    event.preventDefault();
    event.stopPropagation();

    if (onContextMenuOpen) {
      onContextMenuOpen(action, row);
    } else {
      setIsLocalContextMenuOpen(true);
    }
  };

  const handleDelete = () => {
    onDelete?.(action, row);
    closeContextMenu();
  };

  return (
    <>
      <div onContextMenu={handleContextMenu} className={className}>
        <div className={`${className}-text`}>{`${label}: ${action.data.name}`}</div>
      </div>

      {isMenuOpen && (
        <TimelineContextMenu
          onClose={closeContextMenu}
          onDelete={handleDelete}
        />
      )}
    </>
  );
};

export const CustomRenderAudio: FC<{
  action: CustomTimelineAction;
  row: CusTomTimelineRow;
  onDelete?: TimelineActionDeleteHandler;
  isContextMenuOpen?: boolean;
  onContextMenuOpen?: TimelineActionDeleteHandler;
  onContextMenuClose?: () => void;
}> = ({
  action,
  row,
  onDelete,
  isContextMenuOpen,
  onContextMenuOpen,
  onContextMenuClose,
}) => {
  return (
    <TimelineActionBar
      action={action}
      row={row}
      className="effect0"
      label="Audio"
      onDelete={onDelete}
      isContextMenuOpen={isContextMenuOpen}
      onContextMenuOpen={onContextMenuOpen}
      onContextMenuClose={onContextMenuClose}
    />
  );
};

export const CustomRenderAnimation: FC<{
  action: CustomTimelineAction;
  row: CusTomTimelineRow;
  onDelete?: TimelineActionDeleteHandler;
  isContextMenuOpen?: boolean;
  onContextMenuOpen?: TimelineActionDeleteHandler;
  onContextMenuClose?: () => void;
}> = ({
  action,
  row,
  onDelete,
  isContextMenuOpen,
  onContextMenuOpen,
  onContextMenuClose,
}) => {
  return (
    <TimelineActionBar
      action={action}
      row={row}
      className="effect1"
      label="Animation"
      onDelete={onDelete}
      isContextMenuOpen={isContextMenuOpen}
      onContextMenuOpen={onContextMenuOpen}
      onContextMenuClose={onContextMenuClose}
    />
  );
};

export const CustomRenderRiggedAnimation: FC<{
  action: CustomTimelineAction;
  row: CusTomTimelineRow;
  onDelete?: TimelineActionDeleteHandler;
  isContextMenuOpen?: boolean;
  onContextMenuOpen?: TimelineActionDeleteHandler;
  onContextMenuClose?: () => void;
}> = ({
  action,
  row,
  onDelete,
  isContextMenuOpen,
  onContextMenuOpen,
  onContextMenuClose,
}) => {
  return (
    <TimelineActionBar
      action={action}
      row={row}
      className="effect5"
      label="Rigged Character"
      onDelete={onDelete}
      isContextMenuOpen={isContextMenuOpen}
      onContextMenuOpen={onContextMenuOpen}
      onContextMenuClose={onContextMenuClose}
    />
  );
};

export const CustomRenderEffect: FC<{
  action: CustomTimelineAction;
  row: CusTomTimelineRow;
  onDelete?: TimelineActionDeleteHandler;
  isContextMenuOpen?: boolean;
  onContextMenuOpen?: TimelineActionDeleteHandler;
  onContextMenuClose?: () => void;
}> = ({
  action,
  row,
  onDelete,
  isContextMenuOpen,
  onContextMenuOpen,
  onContextMenuClose,
}) => {
  return (
    <TimelineActionBar
      action={action}
      row={row}
      className="effect2"
      label="Effect"
      onDelete={onDelete}
      isContextMenuOpen={isContextMenuOpen}
      onContextMenuOpen={onContextMenuOpen}
      onContextMenuClose={onContextMenuClose}
    />
  );
};

export const CustomRenderText: FC<{
  action: CustomTimelineAction;
  row: CusTomTimelineRow;
  onDelete?: TimelineActionDeleteHandler;
  isContextMenuOpen?: boolean;
  onContextMenuOpen?: TimelineActionDeleteHandler;
  onContextMenuClose?: () => void;
}> = ({
  action,
  row,
  onDelete,
  isContextMenuOpen,
  onContextMenuOpen,
  onContextMenuClose,
}) => {
  return (
    <TimelineActionBar
      action={action}
      row={row}
      className="effect3"
      label="Text"
      onDelete={onDelete}
      isContextMenuOpen={isContextMenuOpen}
      onContextMenuOpen={onContextMenuOpen}
      onContextMenuClose={onContextMenuClose}
    />
  );
};

export const CustomRenderBackground: FC<{
  action: CustomTimelineAction;
  row: CusTomTimelineRow;
  onDelete?: TimelineActionDeleteHandler;
  isContextMenuOpen?: boolean;
  onContextMenuOpen?: TimelineActionDeleteHandler;
  onContextMenuClose?: () => void;
}> = ({
  action,
  row,
  onDelete,
  isContextMenuOpen,
  onContextMenuOpen,
  onContextMenuClose,
}) => {
  return (
    <TimelineActionBar
      action={action}
      row={row}
      className="effect4"
      label="Scene"
      onDelete={onDelete}
      isContextMenuOpen={isContextMenuOpen}
      onContextMenuOpen={onContextMenuOpen}
      onContextMenuClose={onContextMenuClose}
    />
  );
};
